import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React from 'react';
import styled from 'styled-components';
import { AnalyticsContext, trackEvent } from 'latitude-analytics';
import { BREAKPOINT, COLOR, FONT_WEIGHT } from '@latitude/core/utils/constants';
import { Accordion } from '@latitude/accordion';
import SelectList from '@latitude/select-list';

var AccordionSidebar = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(AccordionSidebar, _React$Component);

  function AccordionSidebar(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _this.handleClick = function (analytics) {
      trackEvent(analytics, {
        category: 'select-list',
        action: 'in-page-navigation',
        label: event.target.innerText,
        location: 'faqs'
      });
    };

    _this.setGroup = function (id, analytics, location) {
      _this.setState({
        groupId: id,
        faqId: null
      });

      _this.handleClick(analytics, location);
    };

    _this.getItem = function (id) {
      var selectedItem; // give each accordion / faq item a unique id

      var formatData = function formatData(accordions) {
        var id = 0;
        accordions.map(function (accordion) {
          accordion.groupData.map(function (group) {
            group.id = id;
            id++;
          });
        });
        return accordions;
      }; // loop through the faqs to find the one that matches `id`


      formatData(_this.props.data).map(function (faq, index) {
        var selectedAccordion = faq.groupData.filter(function (group) {
          return group.id === id;
        });

        if (selectedAccordion.length === 1) {
          selectedItem = {
            groupId: index,
            faqId: selectedAccordion.pop().id
          };
        }
      });
      return selectedItem;
    };

    _this.setGroup = _this.setGroup.bind(_assertThisInitialized(_this));
    _this.state = {
      groupId: null,
      faqId: null
    };
    return _this;
  }

  var _proto = AccordionSidebar.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.setState(this.getItem() || {
      groupId: 0,
      faqId: null
    });
  };

  _proto.render = function render() {
    var _this2 = this;

    var selectedGroupId = this.state.groupId || 0;
    var selectedGroupData = this.state.groupId !== null ? this.props.data[selectedGroupId].groupData : null;
    var selectedGroupName = this.state.groupId !== null ? this.props.data[selectedGroupId].groupName : null;
    var selectedFaqId = this.state.groupId !== null ? this.state.faqId : null;
    return /*#__PURE__*/React.createElement(StyledSection, {
      id: "faq-content"
    }, /*#__PURE__*/React.createElement(StyledForMobile, null, /*#__PURE__*/React.createElement(Accordion, {
      borderedChildren: true,
      items: this.props.data.map(function (item) {
        return {
          title: item.groupName,
          content: /*#__PURE__*/React.createElement(Accordion, {
            titleBgColor: "" + COLOR.BLACK,
            contentBgColor: "" + COLOR.BLACK,
            borderedChildren: true,
            style: {
              padding: 16,
              paddingTop: 0
            },
            items: item.groupData
          })
        };
      })
    })), /*#__PURE__*/React.createElement(AnalyticsContext.Consumer, null, function (_ref) {
      var analytics = _ref[0];
      return /*#__PURE__*/React.createElement(StyledForDesktop, null, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-lg-4"
      }, /*#__PURE__*/React.createElement(StyledSelectList, {
        data: _this2.props.data.map(function (item) {
          return item.groupName;
        }),
        selectedItem: selectedGroupId,
        onClick: function onClick(e) {
          return _this2.setGroup(e, analytics);
        }
      })), /*#__PURE__*/React.createElement("div", {
        className: "col-lg-8"
      }, selectedGroupData && /*#__PURE__*/React.createElement(Accordion, {
        key: selectedGroupName,
        selectedId: selectedFaqId,
        items: selectedGroupData,
        style: {
          padding: 16
        },
        category: selectedGroupName
      }))));
    }));
  };

  return AccordionSidebar;
}(React.Component);

export default AccordionSidebar;
/**
 * 24/01/20: Due to the scope of refactoring accordion
 * component we use the below overrides to target the
 * corresponding levels of the component with new branding palette
 */

var StyledSection = /*#__PURE__*/styled.div.withConfig({
  displayName: "AccordionSidebar__StyledSection",
  componentId: "sc-14kipgb-0"
})([".accordion__item{.bg-white{background-color:", "!important;}&-body{font-weight:", ";}.accordion__item{border-top:1px solid ", ";.bg-white{background-color:", "!important;font-weight:", "!important;}&-body{background-color:", "!important;}}ol,ul{margin-top:0;}}"], COLOR.GREY2, FONT_WEIGHT.LIGHT, COLOR.GREY12, COLOR.GREY6, FONT_WEIGHT.LIGHT, COLOR.GREY6);
/**
 * Show/hide accordions based on device
 */

var StyledForMobile = /*#__PURE__*/styled.div.withConfig({
  displayName: "AccordionSidebar__StyledForMobile",
  componentId: "sc-14kipgb-1"
})(["@media (min-width:", "){display:none;}"], BREAKPOINT.LG);
var StyledForDesktop = /*#__PURE__*/styled.div.withConfig({
  displayName: "AccordionSidebar__StyledForDesktop",
  componentId: "sc-14kipgb-2"
})(["display:none;@media (min-width:", "){display:block;}"], BREAKPOINT.LG);
/**
 * Select list brand override
 */

var StyledSelectList = /*#__PURE__*/styled(SelectList).withConfig({
  displayName: "AccordionSidebar__StyledSelectList",
  componentId: "sc-14kipgb-3"
})(["margin:0;padding:0;svg{color:", ";}.select-list__item{border-bottom:1px solid ", ";font-weight:", ";min-height:58px;padding:0 16px;&:hover{border-bottom:1px solid ", ";}&:first-child{border-top:1px solid ", ";}&--active{color:", ";font-weight:", ";justify-content:space-between;&:hover{color:", ";}}}"], COLOR.BLUE, COLOR.GREY12, FONT_WEIGHT.LIGHT, COLOR.GREY12, COLOR.GREY12, COLOR.BODY, FONT_WEIGHT.BOLD, COLOR.BODY);